// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"b99e54f0f787368d9e9e","303":"71b2fa1dbdbf5b3042bd","495":"3eaf51d3da882051eb35"}[chunkId] + ".js";
};